import service from "@/helpers/py-service";

const state = {
  loading: false,
  dashboardData: {},
  //
  meta: {},
  list: [],
  //
};

const mutations = {
  SET_DASHBOARD_DATA(state, payload) {
    state.dashboardData = payload;
  },
  //
  SET_META(state, data) {
    if (data.meta) {
      state.meta.page = data.meta.current_page;
      state.meta.itemsPerPage = data.meta.per_page;
      state.meta.lastPage = data.meta.last_page;
      state.meta.totalItems = data.meta.total;
    }
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  UPDATE_LIST(state, payload) {
    const item = state.list.find((item) => item.id === payload.id);
    Object.assign(item, payload);
  },

  DELETE(state, payload) {
    state.list.splice(state.list.map((o) => o.id).indexOf(payload.id), 1);
  },
};

const actions = {
  dashboard: (store, params) => {
    store.state.loading = true;
    service
      .get(`charging-station/energy-analyzer`, params)
      .then((data) => {
        store.commit("SET_DASHBOARD_DATA", data.body);
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },
  //
  list: (store, params) => {
    store.state.loading = true;
    service
      .get(`charging-station/energy-analyzers`, params)
      .then((data) => {
        store.commit("SET_META", data.body);
        store.commit("SET_LIST", data.body.data);
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },
  add: (store, { payload, filter }) => {
    store.state.loading = true;
    service
      .post(`charging-station/energy-analyzers`, payload)
      .then((data) => {
        store.dispatch("list", filter);
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },
  update: (store, params) => {
    store.state.loading = true;
    return service
      .update(`charging-station/energy-analyzers/${params.id}`, params)
      .then((res) => {
        store.commit("UPDATE_LIST", res.body);
        return res.body;
      })
      .finally(() => (store.state.loading = false));
  },
  destroy: (store, params) => {
    return service
      .destroy(`charging-station/energy-analyzers/${params.id}`, params)
      .then((res) => {
        store.commit("DELETE", params);
        return res;
      });
  },
};

const getters = {
  getLoading(state) {
    return state.loading;
  },
  getDashboardData(state) {
    return state.dashboardData;
  },
  getMeta(state) {
    return state.meta;
  },
  getList(state) {
    return state.list;
  },
};

const energyAnalyzer = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default energyAnalyzer;
